<script setup lang="ts">
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { NCard, NForm, NFormItem, NInput, NButton, NAlert } from 'naive-ui'
import { useAuthStore } from '@/stores/auth'
import { login } from '@/api/auth'

const username = ref('')
const password = ref('')
const error = ref<string | null>(null)
const loading = ref(false)

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

async function onSubmit() {
  if (!username.value || !password.value) {
    error.value = 'Заполните имя пользователя и пароль.'
    return
  }
  error.value = null
  loading.value = true
  try {
    const res = await login({ login: username.value, password: password.value })
    authStore.setAuth(res.access_token, username.value)
    const redirect = (route.query.redirect as string) || '/'
    router.push(redirect)
  } catch (e: unknown) {
    const status = (e as { response?: { status?: number } }).response?.status
    error.value =
      status === 401 ? 'Неверные имя пользователя или пароль.' : 'Ошибка соединения с сервером.'
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="login-wrap">
    <n-card title="Dozor" class="login-card">
      <n-form @submit.prevent="onSubmit">
        <n-form-item label="Имя пользователя">
          <n-input v-model:value="username" autofocus :disabled="loading" />
        </n-form-item>
        <n-form-item label="Пароль">
          <n-input
            v-model:value="password"
            type="password"
            show-password-on="click"
            :disabled="loading"
            @keydown.enter="onSubmit"
          />
        </n-form-item>
        <n-alert v-if="error" type="error" style="margin-bottom: 12px">
          {{ error }}
        </n-alert>
        <n-button type="primary" block :loading="loading" attr-type="submit" @click="onSubmit">
          Войти
        </n-button>
      </n-form>
    </n-card>
  </div>
</template>

<style scoped>
.login-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.login-card {
  width: 100%;
  max-width: 380px;
}
</style>
